import { $ok } from "foundation-ts/commons";
import { SessionDto } from "@bcasmart/doxecure-commons/doxecureClientTypes";
import { SectionCategory, SessionActorType } from "@bcasmart/doxecure-commons/doxecureTypes";

import { Dashboard, SessionFilter } from "@containers/generics/Dashboard";
import { SectionInfos } from "@containers/generics/SectionsList";
import { useAuthContext } from "@hooks/useAuthContext";
import { $g1Color } from "@/theme/G1Style";
import { BaseViewProps, sectionMap } from "@utils/TypesAndConstants";
import { canSessionBeApproved, canSessionBeSigned, okOrError, optlog } from "@utils/functions";

// @ts-ignore
const tosignSectionInformations = (category?: SectionCategory): SectionInfos => {
    const component = `list.${category === "to-be-signed" ? 'tosign' : 'tobeapproved'}.${$ok(category) && (category === "urgent") ? "urgent." : ""}` ;
    const header = $ok(category) ? sectionMap.get(category!) : undefined ;

    return {
        title:header?.title || `*** DEBUG SECTION ${category} ***`,
        description:header?.description || `*** SECTION DESCRIPTION ***`,
        style: {
            bg: $g1Color(`${component}bg`),
            color: $g1Color(`${component}write`),
            borderTopColor: $g1Color('list.spacer'),
            rounded: { base: "lg" },
        },
        itemStyle: {
            borderTop: "1px",
            borderTopColor: $g1Color('list.spacer'),
            hover: { bg: $g1Color(`${component}hover.bg`), color: $g1Color(`${component}hover.write`) },
            select: { bg: $g1Color(`${component}select.bg`), color: $g1Color(`${component}select.write`) },
        }
    } ;
}

export const DashboardView = (props: BaseViewProps) => {
    const { lockedAccount } = props;
    const { connectedProfileId } = useAuthContext() ;
    optlog(`+++ DashboardView initialized with profile ID '${connectedProfileId}'`) ;
    const sessionFilter:SessionFilter = (session:SessionDto, _:SectionCategory):boolean => !!canSessionBeApproved(session, connectedProfileId) || !!canSessionBeSigned(session, connectedProfileId) ;

    return okOrError(
        connectedProfileId,
        (<Dashboard 
            // we don't pass any category here, which means that we want all the
            // to-be-approved, to-be-signed, urgent and expired sessions as a signer
            title="Mon Parapheur"
            emptyMessage="Pas de documents à signer ou approuver"
            roles={[SessionActorType.Approver, SessionActorType.Signer]}
            immutableDocuments={true}
            acceptsSignature={true}
            lockedAccount={lockedAccount}
            sectionInfos={tosignSectionInformations}
            sessionFilter={sessionFilter}
        />),
        false,
        "Impossible d'afficher le parapheur car l'identifiant de profil de la personne connectée n'a pas pu être récupéré.",
        "Connexion invalide"
    ) ;
};
